function onClickOutside(event, el, handler, excludeSelector = null) {
  const isClickOutside = event.target !== el && !el.contains(event.target);
  const isClickOnExcluded = excludeSelector && event.target.closest(excludeSelector);

  if (!isClickOutside || isClickOnExcluded) return null;

  return handler(event, el);
}

const instances = new Map();

function toggleEventListeners(handler) {
  return (action) => {
    document[`${action}EventListener`]('click', handler, true);
  }
}

function mounted(el, binding) {
  const handler = typeof binding.value === 'function' ? binding.value : binding.value?.handler;
  const excludeSelector = binding.value?.exclude || null;

  const eventHandler = (event) => onClickOutside(event, el, handler, excludeSelector);
  toggleEventListeners(eventHandler)('add');

  instances.set(
    el,
    eventHandler,
  );
}

function unmounted(el) {
  const eventHandler = instances.get(el);
  toggleEventListeners(eventHandler)('remove');

  instances.delete(el);
}

const directive = {
  mounted,
  unmounted,
};

export default directive;